import { render, staticRenderFns } from "./ViewIncidentCommunications.vue?vue&type=template&id=313e48e6&scoped=true&"
import script from "./ViewIncidentCommunications.vue?vue&type=script&lang=js&"
export * from "./ViewIncidentCommunications.vue?vue&type=script&lang=js&"
import style0 from "./ViewIncidentCommunications.vue?vue&type=style&index=0&id=313e48e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e48e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VProgressCircular,VRow})
